// fr.gestionpial.user.services.UserSearchServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';
import { GestionPialRight } from '../entities/GestionPialRight';
import { UserLiteDTO } from '../entities/UserLiteDTO';

@Injectable({
  providedIn: 'root',
})
export class UserSearchService {
  private irpc = inject(IRPC);

  searchUser = (txt: string, rights: GestionPialRight[]): RpcRequestBuilder<UserLiteDTO[]> => {
    const req = new JSONRpcRequest();
    req.method = 'UserSearchService.searchUser';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(txt, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(rights, 'java.util.List<fr.gestionpial.GestionPialRight>', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, 'java.util.List');
  };

}
